<!--<!DOCTYPE html>-->
<!--<html lang="en">-->

<!--<head>-->
<!--  <meta charset="UTF-8">-->
<!--  <meta name="viewport"-->
<!--    content="width=device-width,initial-scale=1.0,maximum-scale=3,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover" />-->
<!--  <title>智慧农业ERP官网</title>-->
<!--  <meta name="keywords" content="" />-->
<!--  <meta name="description" content="" />-->
<!--  <meta name="referrer" content="never" />-->
<!--  <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests" />-->
<!--  <meta http-equiv="Access-Control-Allow-Origin" content="*" />-->
<!--  <link rel="icon" href="" type="image/x-icon" /> &lt;!&ndash; 在网页标题左侧显示图标 &ndash;&gt;-->
<!--  <link rel="shortcut icon" href="@/assets/img/zhny.ico" type="image/x-icon" /> &lt;!&ndash; 在收藏夹显示图标 &ndash;&gt;-->
<!--  <link rel="stylesheet" href="css/element.css" />-->
<!--  <link rel="stylesheet" href="css/index.css?v=5.16" />-->
<!--  <script src="js/vue.js"></script>-->
<!--  <script src="js/jquery-2.0.2.min.js"></script>-->
<!--  <script src="js/element.js"></script>-->
<!--  <script src="js/action.js"></script>-->
<!--</head>-->

<!--<body> node环境 8.17.0 -->
<template>
<!--  <div>-->
  <div class="index" v-cloak>
<!--    <el-button @click="test"> test </el-button>-->
    <!-- 头部 -->
    <Header/>
    <!-- 轮播图 -->
    <div class="carousel" style="height: 37.5rem;">
      <el-carousel :interval="95000">
        <el-carousel-item v-for="(item, index) in carouselList" :key="index">
          <div class="cs_contain" :style='{ backgroundImage : "url(" + item.url + ")" }'>
            <div class="content-width">
              <div :class="['cs_word', index === 2 ? 'cs_word3' : '']" style="padding-top: 13.5rem;">
                <div v-cloak v-if="item.title1" class="title1">{{item.title1}}</div>
                <div v-cloak class="title2">{{item.title2}}</div>
                <div v-cloak class="remark">{{item.remark}}</div>
              </div>
              <el-button type="primary" round class="use_btn" style="top: 20.75rem;" @click="useClick">申请试用</el-button>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 产品 -->
    <div class="product">
      <div class="content content-title">
        <div class="title">穗盈生鲜供应链系统</div>
        <div class="remark">穗盈生鲜供应链系统作为广州市智慧农业服务股份有限公司自主研发的核心产品，通过数字化技术优化食材供应链的每一个环节，
          为生鲜配送企业提供从订单管理、采购、库存管理到分拣配送、财务管理、经营分析的全流程覆盖，服务于以下客户群体。</div>
        <ul style="margin-top: 1.425rem;">
          <li>
            <img src="@/assets/img/index/icon/function1.svg" />
            <div class="sub-title">中小型配送商</div>
<!--            <div class="sub-remark">覆盖系统所有成本来源</div>-->
<!--            <div class="sub-remark">自动定价</div>-->
<!--            <div class="sub-remark">每天节约2小时调价</div>-->
          </li>
          <li>
            <img src="@/assets/img/index/icon/function2.svg" />
            <div class="sub-title">大型生鲜配送供应链企业</div>
<!--            <div class="sub-remark">多终端自助下单</div>-->
<!--            <div class="sub-remark">操作简单</div>-->
<!--            <div class="sub-remark">常用商品1分钟快速下单</div>-->
          </li>
          <li>
            <img src="@/assets/img/index/icon/function3.svg" />
            <div class="sub-title">国有生鲜配送供应链企业</div>
<!--            <div class="sub-remark">自主分配采购数据</div>-->
<!--            <div class="sub-remark">系统汇总订单商品信息</div>-->
          </li>
          <li>
            <img src="@/assets/img/index/icon/function4.svg" />
            <div class="sub-title">集采供应商</div>
<!--            <div class="sub-remark">多种分拣方式自由选择</div>-->
<!--            <div class="sub-remark">实际斤两出库，智能去皮</div>-->
<!--            <div class="sub-remark">分拣进度实时查看</div>-->
          </li>
<!--          <li>-->
<!--            <img src="@/assets/img/index/icon/function_5data.svg" />-->
<!--            <div class="sub-title">数据同步</div>-->
<!--            <div class="sub-remark">多维度数据穿透</div>-->
<!--            <div class="sub-remark">时刻掌握企业运营状况</div>-->
<!--            <div class="sub-remark">发现问题及时调整</div>-->
<!--          </li>-->
        </ul>
        <img class="productImg" style="margin-top: 2.25rem;" src="@/assets/img/index/pic/product.jpg" />
      </div>
    </div>
    <!-- 客服 -->
    <CustCare />
    <!-- 直击行业痛点 -->
    <div class="carousel info">
      <div class="content content-title" style="height: auto;">
        <div class="title">直击行业痛点</div>
        <div class="remark" style="width: 28.8rem;">传统人工管理模式下，食材配送过程中容易出现信息不透明、流转效率低下的问题 亟需通过全流程数字化转型突破困境</div>
      </div>
        <div class="content" style="height: 30.8rem;">
            <!-- <div class="title">智慧资讯</div>
            <div class="remark">时刻为您提供智慧农业最新资讯和产品动态</div> -->
            <div class="infoList painPoint">
              <div class="sonItem" v-for="(sonItem, sonIndex) in painPointsList" :key="sonIndex">
<!--                <img v-if="sonItem.isNew" class="isNew" src="@/assets/img/institute/icon/new.svg" />-->
                <img class="info_img" :src="sonItem.picture || '@/assets/img/index/pic/info.jpg' " />
                <div class="info_title ellipsis">{{sonItem.title}}</div>
                <div class="ellipsis info_remark">{{sonItem.remark1}}</div>
                <div class="ellipsis info_remark info_remark2">{{sonItem.remark2}}</div>
            </div>
          </div>
        </div>
    </div>
    <!-- 痛点解法 -->
    <div class="partner" style="height: 45rem;background: linear-gradient(0deg, #E8F5FF, #FFFFFF);">
      <div class="content content-title">
        <div class="title">痛点解法</div>
        <div class="remark">穗盈生鲜SCM系统提供食材配送全流程数字化解决方案，帮助企业实现从内部管理到外部协同的端到端数字化升级</div>
        <img class="partner-bg" style="height: 29.6rem" src="@/assets/img/index/pic/solution.png" />
      </div>
    </div>
    <!-- 食材配送全链数字化 -->
    <div class="partner digital">
      <div class="content content-title">
        <div class="title">食材配送全链数字化</div>
        <div class="remark">集成订单、下单、采购、分拣、食安、财务等核心管理功能，实现从客户需求到供应商协作的无缝对接</div>
<!--        <img class="partner-bg" src="@/assets/img/index/pic/digital.jpg" />-->
      </div>
    </div>
    <!-- 伙伴 -->
    <div class="partner" style="height: 46.8rem;background: linear-gradient(0deg, #E8F5FF, #FFFFFF);">
      <div class="content content-title">
        <div class="title">合作伙伴</div>
        <div class="remark">打破传统食材配送信息壁垒，降低流转成本，为合作企业构建高效、透明的业务闭环</div>
        <img class="partner-bg" style="height: 30rem;margin-top: 2rem;" src="@/assets/img/index/pic/partner.png" />
      </div>
    </div>

    <!-- 申请 -->
    <Apply ref="applyRef" />
    <!-- 页面申请 -->
    <ApplyIndex />
    <!-- 联系 -->
    <Contact />
    <!-- 尾部 -->
    <Footer />
    <!-- 微信分享 start-->
    <!--  <div class="bdsharebuttonbox" style="display:none;">-->
    <!--    <xx style="float: left; font-size: 12px;line-height:30px;"> </xx>-->
    <!--    <a href="#" class="bds_weixin" data-cmd="weixin" title="分享到微信" id="wx_share"></a>-->
    <!--  </div>-->
    <!--  </div>-->
  </div>

</template>
<script>
  import axios from 'axios'
  import Header from '@/views/pc/components/header'
  import Contact from '@/views/pc/components/contact'
  import CustCare from '@/views/pc/components/custCare'
  import Footer from '@/views/pc/components/footer'
  import Apply from '@/views/pc/components/apply'
  import ApplyIndex from '@/views/pc/components/applyIndex'
  import { formatDate } from '@/utils/dateFormat'
  export default {
    name: "Index",
    components: { Header, Contact, CustCare, Footer, Apply, ApplyIndex },
    data () {
      return {
        baseUrl: this.$baseUrl,
        // 首页轮播图
        carouselList: [
          {
            // title1: '全流程一体化',
            title2: '穗盈生鲜供应链系统',
            remark: '降本增效，重构食材配送逻辑',
            url: require('@/assets/img/index/pic/cs1.jpg')
          },
          {
            title1: '致力于中国农业',
            title2: '产业链数字化升级',
            // remark: '效率高、简单易用、降低损耗及成本',
            url: require('@/assets/img/index/pic/cs2.jpg')
          },
          // {
          //   title2: '企业升级转型信息化',
          //   remark: '效率高、简单易用、降低损耗及成本',
          //   url: require('@/assets/img/index/pic/cs3.jpg')
          // }
        ],
        //首页资讯列表-拼接
        indexInfoList: [],
        painPointsList: [
          {
            picture: require('@/assets/img/index/pic/info1.jpg'),
            title: '单据易丢失',
            remark1: '来回打印浪费纸张',
            remark2: '对单找货难查找',
          },
          {
            picture: require('@/assets/img/index/pic/info2.jpg'),
            title: '配送效率低',
            remark1: '分拣现场混乱',
            remark2: '送达现场才发现串货',
          },
          {
            picture: require('@/assets/img/index/pic/info3.jpg'),
            title: '收款难度大',
            remark1: '对账验收耗时耗力',
            remark2: '和供应商来回扯皮',
          },
          {
            picture: require('@/assets/img/index/pic/info4.jpg'),
            title: '数据难监管',
            remark1: '系统数据同步速度慢',
            remark2: '数据准确性难保证',
          },
        ],
        // 申请成功弹框
        successVisible: false,
        // 公告新闻消息 tab状态
        activeNameInfo: 'first',
        infoUrl: 'instituteInfo.html',
        nameFlag: false,
        telFlag: false,
        textTel: '请输入手机号',
        textName: '请输入姓名'
      }
    },
    created() {
      this.getIndexNewsList()
    },
    methods: {
      test() {
        this.$router.push('/test');
      },
      // 新闻公告详情跳转
      getInfo (id) {
        this.$router.push({name:'InstituteInfo',query:{id:id}});
      },
      // 试用
      useClick () {
        this.$refs.applyRef.useClick();
        // this.closeApply()
      },
      // 新闻列表
      getIndexNewsList() {
        let that = this
        let _data = {
          type: 2,
          pageNum: 1,
          pageSize: 12,
          systemType: 1,
        }
        let indexInfoList = []
        let obj = []
        let index = []
        const url = that.baseUrl + "/message/news/list"
        axios.get(url, { params: _data }).then(res=>{
          const list = res.data.newsMap
          if (list) {
            let newList = list.rows
            if (newList.length > 2) {
              for (let i = 0; i < newList.length; i++) {
                newList[i].publishTime = formatDate(newList[i].publishTime)
                index.push(newList[i])
                if (index.length === 4) {
                  obj['list'] = index
                  indexInfoList.push(obj)
                  index = []
                  obj = []
                }
              }
            } else if (newList.length === 2) {
              for (let i = 0; i < newList.length; i++) {
                newList[i].publishTime = formatDate(newList[i].publishTime)
                index.push(newList[i])
                if (index.length === 2) {
                  obj['list'] = index
                  indexInfoList.push(obj)
                  index = []
                  obj = []
                  break
                }
              }
            } else if (newList.length === 1) {
              for (let i = 0; i < newList.length; i++) {
                newList[i].publishTime = formatDate(newList[i].publishTime)
                index.push(newList[i])
                obj['list'] = index
                indexInfoList.push(obj)
                index = []
                obj = []
              }
            }

          }
        })
        setTimeout(e => {
          if (indexInfoList.length > 0) {
            that.indexInfoList = indexInfoList
          }
        }, 1500)
      },
      share (pType) {
        var pUrl = window.location.href; //当前的url地址
        this.shareys(pType, pUrl);
      },
      //以下shareys是主要的分享的api接口
      shareys (type, url) {
        const title = '智慧农业Erp官网'
        switch (type) {
          case "sina":
            url = "http://service.weibo.com/share/share.php?title=" + encodeURIComponent('「' + title + '」' + ' 点这里' + url);
            window.open(url);
            break;
          case "tqq":
            url = "http://share.v.t.qq.com/index.php?c=share&a=index&url=" + encodeURIComponent(url) + '&title=' + encodeURIComponent(title);
            window.open(url);
            break;
          case "qzone":
            url = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title);
            window.open(url);
            break;
          default:
            break;
        }
      },
      //分享到微信朋友圈
      share_wx(){
        var el = document.getElementById('wx_share');
        el.target = '_new';
        el.click();
      }
    }
  }
  </script>
<style lang="scss">
  @import '@/styles/pc/common/index.scss';
</style>
<style lang="scss" scoped>
  @import "@/styles/pc/carousel/index.scss";
  @import '@/styles/pc/index/index.scss';
</style>



// WEBPACK FOOTER //
// src/views/pc/index.vue